/*
 *  Copyright (c) Qwoach LLC 2020. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 7/10/2020
 */

import BaseObject from "@shared/BaseObject";
import RecurrencePatternItem from "@shared/Recurrence/RecurrencePatternItem";
import RecurrenceRangeItem from "@shared/Recurrence/RecurrenceRangeItem";
import {Type} from "class-transformer";
import {RecurrenceRangeType} from "@shared/Recurrence/RecurrenceEnums";

export default class RecurrenceItem extends BaseObject{

	@Type(() => RecurrencePatternItem)
	pattern: RecurrencePatternItem = new RecurrencePatternItem()

	@Type(() => RecurrenceRangeItem)
	range: RecurrenceRangeItem = new RecurrenceRangeItem()

	constructor() {
		super();
	}

	isRangeByCount(){
		return this.range.type === RecurrenceRangeType.COUNT
	}
	isRangeByDate(){
		return this.range.type === RecurrenceRangeType.BY_DATE
	}
	isRangeNoEnd(){
		return this.range.type === RecurrenceRangeType.NO_END
	}

	// equals(other){
	// 	console.log("RecurrenceItem.equals: other = ", other)
	// 	if(!other){
	// 		console.log("RecurringItem.equals = false: other is null")
	// 		return false
	// 	}
	// 	if(!this.pattern.equals(other.pattern)){
	// 		console.log("RecurringItem.equals = false: other pattern changed")
	// 		return false
	// 	}
	// 	if(!this.range.equals(other.range)){
	// 		console.log("RecurringItem.equals = false: other range changed")
	// 		return false
	// 	}
	// 	return true
	// }



}


export function recurrenceValidator(){
	return (rule, recurrence, callback, source, options) => {
		let errorMsg
		if (recurrence.isRangeByDate() && !recurrence.range.endDateTs) {
			errorMsg = "Please provide end date for the sessions"
		}
		if (recurrence.isRangeByCount() && (!recurrence.range.numberOfOccurrences || recurrence.range.numberOfOccurrences < 1)) {
			errorMsg = "Please set the number of sessions"
		}
		// if (this.form.recurrence.isRangeByCount() && this.form.recurrence.range.numberOfOccurrences > 50) {
		// 	errorMsg = "Maximum number of sessions is 50. If you need to set more, please consider setting 'end date' instead"
		// }
		if (recurrence.pattern.interval < 1) {
			errorMsg = "Please put a number for the 'Repeats every...' field"
		}
		// console.log("this.form.recurrence.pattern.numberOfSelectedDays() = ", this.form.recurrence.pattern.numberOfSelectedDays())
		if (recurrence.pattern.numberOfSelectedDays() === 0) {
			errorMsg = "Please select at least one day of the week"
		}
		if (!recurrence.range.type) {
			errorMsg = "Please select when these sessions end"
		}

		callback(errorMsg);
	}
}



